import { toast } from "sonner";

/**
 * Abre un adjunto en nueva pestaña. Las URLs data: muy largas suelen fallar con target=_blank;
 * se convierten a blob URL primero.
 * @param {string} url
 */
export async function openAdjuntoEnNuevaPestana(url) {
  if (!url) return;
  if (url.startsWith("data:")) {
    try {
      const res = await fetch(url);
      const blob = await res.blob();
      const blobUrl = URL.createObjectURL(blob);
      const w = window.open(blobUrl, "_blank", "noopener,noreferrer");
      if (!w) {
        toast.error("Permite ventanas emergentes para ver el archivo");
        URL.revokeObjectURL(blobUrl);
        return;
      }
      setTimeout(() => URL.revokeObjectURL(blobUrl), 120000);
    } catch {
      toast.error("No se pudo abrir el archivo");
    }
    return;
  }
  window.open(url, "_blank", "noopener,noreferrer");
}
